import { ref } from 'vue';
import { paramsURL } from '../helpers';

export function useCarregarMais({
  path,
  paginaInicial = 1,
  proximaPaginaInicial = null,
  seletorLinhas = '#pedidos-table-body > tr',
  idCarregados = 'pedidos-carregados-count',
  idTotal = 'pedidos-total-count',
  mensagemErro = 'Não foi possível carregar mais pedidos. Tente novamente.'
}) {
  const paginaAtual = ref(Number(paginaInicial) || 1);
  const proximaPagina = ref(proximaPaginaInicial ? Number(proximaPaginaInicial) : null);
  const loading = ref(false);
  const erro = ref(false);

  function montarParametros() {
    try {
      const { paramsObject } = paramsURL();
      delete paramsObject.format;
      return paramsObject;
    } catch (e) {
      const params = new URLSearchParams(window.location.search);
      return Object.fromEntries(params);
    }
  }

  function exibirAlertaDeErro() {
    if (typeof window.exibe_erro === 'function') {
      window.exibe_erro(mensagemErro);
    }
  }

  function atualizarContagem() {
    const linhasCarregadas = document.querySelectorAll(seletorLinhas).length;
    const elementoCarregados = document.getElementById(idCarregados);
    const elementoTotal = document.getElementById(idTotal);

    if (elementoCarregados) {
      elementoCarregados.textContent = linhasCarregadas;
      elementoCarregados.setAttribute('data-total-loaded', linhasCarregadas);
    }

    if (elementoTotal) {
      const totalAtual = parseInt(elementoTotal.textContent, 10);
      if (!Number.isNaN(totalAtual) && linhasCarregadas > totalAtual) {
        elementoTotal.textContent = linhasCarregadas;
      }
    }
  }

  function carregar() {
    if (loading.value) return Promise.resolve();

    const proxima = proximaPagina.value || paginaAtual.value + 1;
    loading.value = true;
    erro.value = false;

    const dadosBase = montarParametros();
    const dados = {
      ...dadosBase,
      page: proxima,
      carregar_mais: true
    };

    return new Promise((resolve) => {
      window.$.rails.ajax({
        url: path || window.location.pathname,
        type: 'GET',
        dataType: 'script',
        data: dados,
        success: () => {
          paginaAtual.value = proxima;
          atualizarContagem();
        },
        error: () => {
          erro.value = true;
          exibirAlertaDeErro();
        },
        complete: () => {
          loading.value = false;
          resolve();
        }
      });
    });
  }

  function reset() {
    paginaAtual.value = 1;
    erro.value = false;
    loading.value = false;
  }

  return {
    paginaAtual,
    proximaPagina,
    loading,
    erro,
    carregar,
    reset,
    atualizarContagem
  };
}
